<template>
  <div class="liuyan">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../assets/images/dongguologo.jpg"
    />
    <div class="tit">
      <!-- <h3>留言/咨询</h3> -->
      <img src="../../assets/images/留言咨询.png" alt="" />
    </div>
    <!-- <div class="formbox">
      <div class="formbk">
        <el-form label-width="81px">
          <el-form-item label="姓　　名">
            <span class="icon">*</span>
            <el-input v-model="username" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号码">
            <span class="icon">*</span>
            <el-input
              type="number"
              v-model="mobile"
              placeholder="联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="当前学历">
            <span class="icon">*</span>
            <el-select v-model="xueli" placeholder="当前学历">
              <el-option
                v-for="item in formxueliList"
                :key="item.S99_CodeId"
                :label="item.S99_Name"
                :value="item.S99_CodeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="意向专业">
            <el-input v-model="zy" placeholder="意向专业"></el-input>
          </el-form-item>
          <el-form-item label="留　　言">
            <el-input
              type="textarea"
              placeholder="留言"
              v-model="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="button" @click="registerOne">提交</div>
      </div>
    </div> -->
    <el-form :model="formLabelAlign" label-width="0px">
      <el-form-item>
        <p>您的姓名<span class="icon">*</span></p>
        <el-input
          v-model.trim="formLabelAlign.name"
          placeholder="姓名"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <p>手机号码<span class="icon">*</span></p>
        <el-input
          v-model="formLabelAlign.phone"
          placeholder="联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <p>当前学历<span class="icon">*</span></p>
        <el-select v-model="formLabelAlign.xueli" placeholder="当前学历">
          <el-option
            v-for="item in formxueliList"
            :key="item.S99_CodeId"
            :label="item.S99_Name"
            :value="item.S99_CodeId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <p>意向专业<span class="icon" style="opacity: 0">*</span></p>
        <el-input
          v-model.trim="formLabelAlign.zhuanye"
          placeholder="意向专业"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <p>您的留言<span class="icon" style="opacity: 0">*</span></p>
        <el-input
          type="textarea"
          v-model.trim="formLabelAlign.liuyan"
          placeholder="留言"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="button" @click="sbmitForm">提 交</div>
  </div>
</template>

<script>
import { Notify } from "vant";
export default {
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: "keywords",
          content: "留言咨询",
        },
        {
          name: "description",
          content:
            "对韩国东国大学招生简章、入学申请、报名条件、申请材料不明白的地方,或是想报名的同学就在这里留言咨询吧！",
        },
      ],
    };
  },
  data() {
    return {
      title: "留言咨询-韩国东国大学中文网",
      //form表单
      // username: "", // 姓名
      // mobile: "", // 电话
      // textarea: "", // 留言
      // zy: "", // 意向专业
      // xueli: "", // 学历
      // formxueliList: [], // 学历
      //form表单
      formxueliList: [],
      formLabelAlign: {
        name: "", //您的姓名
        phone: "", //联系方式
        xueli: "", //目前学历
        zhuanye: "", //意向专业
        liuyan: "",
      },
    };
  },
  activated() {
    this.$emit("handleTKD", "报名入口");
  },
  methods: {
    //form表单提交
    sbmitForm() {
      let _form = this.formLabelAlign;
      if (!_form.name) {
        Notify({ type: "warning", message: "请输入姓名！" });
        return false;
      }
      if (!this.formLabelAlign.phone) {
        Notify({ type: "warning", message: "请输入手机号码" });
        return true;
      } else {
        if (!Number(this.formLabelAlign.phone)) {
          Notify({ type: "warning", message: "手机号码只能为数字类型！" });
          this.formLabelAlign.phone = "";
          return false;
        }
      }
      if (!_form.xueli) {
        Notify({ type: "warning", message: "请输选择当前学历！" });
        return false;
      }
      this.$axios
        .post("/trip/InfoSources/WebRegister", {
          C01_Name: _form.name, //姓名
          C01_Tel: _form.phone, //联系方式
          EducationCode: _form.xueli, //当前学历
          C01_Major: _form.zhuanye, //意向专业
          C01_Message: _form.liuyan, //留言
          C01_Origin: 239, //来源于那个官网
        })
        .then((res) => {
          if (res.data.Code == 200) {
            Notify({ type: "success", message: "提交成功！" });
            this.formLabelAlign.name = "";
            this.formLabelAlign.phone = "";
            this.formLabelAlign.xueli = "";
            this.formLabelAlign.zhuanye = "";
            this.formLabelAlign.liuyan = "";
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
    // registerOne() {
    //   let username = this.username;
    //   let mobile = this.mobile;
    //   let xueli = this.xueli;

    //   if (!username) {
    //     this.$message.error("请输入您的姓名");
    //     this.username = "";
    //     return false;
    //   }
    //   if (!mobile) {
    //     this.$message.error("请输入手机号码");
    //     this.mobile = "";
    //     return false;
    //   }
    //   if (!xueli) {
    //     this.$message.error("请选择当前学历！");
    //     return false;
    //   }
    //   this.$axios
    //     .post("/trip/InfoSources/WebRegister", {
    //       C01_Name: this.username, // 姓名
    //       C01_Tel: this.mobile, // 手机号码
    //       C01_Major: this.zy, // 意向专业
    //       EducationCode: this.xueli, // 学历
    //       C01_Origin: 239,
    //       C01_Message: this.textarea, // 留言
    //       C01_IpAddress: sessionStorage.getItem("currentIp")
    //         ? sessionStorage.getItem("currentIp")
    //         : "0.0.0.0",
    //     })
    //     .then((res) => {
    //       if (res.data.Message == "success") {
    //         this.$message.success("提交成功！");
    //         this.username = "";
    //         this.mobile = "";
    //         this.xueli = "";
    //         this.zy = "";
    //         this.textarea = "";
    //       }
    //     });
    // },
  },
  mounted() {
    //获取form表单学历
    this.$axios
      .post("/trip/TokenPass/GetClueCode", {
        S99_GroupCode: "035",
      })
      .then((res) => {
        res.data.Data.forEach((element) => {
          this.formxueliList.push(element);
        });
      });
  },
};
</script>

<style lang="scss" scoped>
.liuyan {
  margin-top: 134px;
  padding-top: 60px;
  margin-bottom: 60px;
  letter-spacing: 1px;
  .tit {
    // h3 {
    //   font-size: 36px;
    //   font-family: Source Han Sans CN;
    //   font-weight: 600;
    //   color: #333333;
    //   text-align: center;
    // }
    width: 174px;
    height: 40px;
    margin: auto;
    margin-bottom: 40px;
    img {
      width: 174px;
      height: 40px;
    }
  }
  /deep/.el-form {
    width: 580px;
    margin: 0 auto;
    margin-top: 130px;
    .el-form-item {
      margin-bottom: 110px;
      p {
        display: flex;
        position: absolute;
        z-index: 1;
        top: -87px;
        left: 0px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        .icon {
          color: #ff0000;
          margin-left: 5px;
          margin-top: -1px;
        }
        .huise {
          color: #999999;
          margin-left: 10px;
        }
      }
      .el-select,
      .el-input {
        width: 100%;
      }
      .el-form-item__content {
        .el-input__inner {
          font-size: 26px;
          line-height: 78px;
          width: 100%;
          height: 78px;
          background: #fdfdfd;
          border: 2px solid #dddddd;
          border-radius: 8px;
        }
      }
      .el-textarea {
        .el-textarea__inner {
          font-size: 26px;
          width: 100%;
          height: 235px;
          border-radius: 8px;
          background: #fdfdfd;
          resize: none;
          padding: 10px 23px;
          -webkit-appearance: none;
          border: 2px solid #dddddd;
        }
      }
    }
    .el-form-item:last-child {
      margin-bottom: 0px;
    }
  }
  .button {
    width: 220px;
    background: #f48729;
    border-radius: 30px;
    text-align: center;
    margin: 0 auto;
    cursor: pointer;
    font-size: 30px;
   
    font-weight: bold;
    color: #ffffff;
    margin-top: 40px;
    padding-top: 12px;
    padding-bottom: 6px;
  }
  // .formbox {
  //   width: 600px;
  //   margin: auto;
  //   position: relative;
  //   .formbk {
  //     margin: 0 auto;
  //     width: 600px;
  //     border-radius: 10px;
  //     background: #ffffff;
  //     border-radius: 20px;
  //     z-index: 1;
  //     /deep/.el-form {
  //       margin: 0 auto;
  //       .el-form-item {
  //         margin-bottom: 30px;
  //         width: 570px;
  //         height: 70px;
  //         .el-form-item__label {
  //           // text-align: justify;
  //           // text-align-last: justify;
  //           font-size: 24px;
  //           font-family: Source Han Sans CN;
  //           font-weight: 400;
  //           color: #333333;
  //         }
  //         .icon {
  //           position: absolute;
  //           font-size: 14px;
  //          
  //           font-weight: bold;
  //           color: #ff0000;
  //           z-index: 1;
  //           top: 5px;
  //           left: 30px;
  //         }
  //         .el-input__suffix {
  //           top: 6px;
  //         }
  //         .el-form-item__error {
  //           left: 1.3rem;
  //         }
  //         .el-form-item__content {
  //           height: 70px;
  //           .el-input__inner {
  //             padding-left: 44px;
  //             font-size: 26px;
  //             width: 440px;
  //             height: 70px;
  //             background: #ffffff;
  //             border: 2px solid #acacac;
  //             border-radius: 8px;
  //             line-height: 70px;
  //           }
  //           .el-textarea__inner {
  //             padding-left: 44px;
  //             font-size: 26px;
  //             width: 440px;
  //             height: 140px;
  //             margin-top: 30px;
  //             background: #ffffff;
  //             border: 1px solid #acacac;
  //             border-radius: 8px;
  //             margin-top: 15px;
  //             resize: none;
  //           }
  //           .el-input__suffix {
  //             top: 0;
  //           }
  //         }
  //       }
  //     }
  //     .button {
  //       width: 220px;
  //       height: 60px;
  //       background: #f48729;
  //       border-radius: 30px;
  //       text-align: center;
  //       margin: 0 auto;
  //       cursor: pointer;
  //       letter-spacing: 1px;
  //       font-size: 28px;
  //      
  //       font-weight: 400;
  //       color: #ffffff;
  //       line-height: 60px;
  //       margin-top: 140px;
  //     }
  //   }
  // }
}
</style>
